import { GeneralService } from 'src/app/services/general.service';
import { Component, OnInit } from '@angular/core';
import { FormularioService } from 'src/app/services/formulario.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-upload-file-to-s3',
    templateUrl: './upload-file-to-s3.component.html',
    styleUrls: ['./upload-file-to-s3.component.scss']
})

export class UploadFileToS3Component implements OnInit {
    public formulario: FormGroup;
    public isReadyOnly: boolean;
    public data:any;
    public showAlert:boolean = false;
    public showAlertError:boolean = false;
    public fileName:string;
    public userName:string;

    constructor(
        protected generalService: GeneralService,
        protected formBuilder: FormBuilder,
        protected formularioService: FormularioService,
        protected notificationService: NotificationService,
        private route: Router
    ) { }

    async ngOnInit(){
        this.isReadyOnly = true;
        
        await this.generalService.getUserNameValue().subscribe(async (response) => {
            this.userName = response;
        });

        this.checkUserAccess();
    }

    handleUpload(event) {
        const file = event.target.files[0];
        this.fileName = event.target.files[0].name;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64result = String(reader.result);
            this.data = base64result.split(',')[1];
        };
    }

    save() {
        if (this.data) {
            this.generalService.postUploadPc003(this.data, this.fileName).subscribe( 
                () => {
                    this.showAlert = true,
                    setTimeout(() => {
                        this.showAlert = false;
                    }, 5000)
                }, 
                error => {
                    this.showAlertError = true,
                    setTimeout(() => {
                        this.showAlertError = false;
                    }, 5000)
                }
            )
        }
    }

    async checkUserAccess() {
        await this.generalService.getAccessUpload(this.userName).subscribe(async (response) => {
            this.getAuthorizedUser(response.user_name)
        });
    }

    getAuthorizedUser(authorizedUser) {
        if (!authorizedUser) {
            this.route.navigate(['/']);
        }
    }

}